import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClickAddButton: () => void
  onClickLinkButton: () => void
}

const NoProjectsMessage = ({ onClickAddButton, onClickLinkButton }: Props) => {
  return (
    <Box textAlign="center" gap="s8" maxWidth="s600" paddingX="s24">
      <Text weight="medium" size="400" color="grey1000">
        {i18n.t('finance.contacts.contact_details.projects.no_projects_message.title')}
      </Text>
      <Text weight="normal" size="300" color="grey800">
        {i18n.t('finance.contacts.contact_details.projects.no_projects_message.description')}
      </Text>

      <Box paddingTop="s12" flexDirection="row" justifyContent="center">
        <PopoverMenu type="list">
          <PopoverMenu.Trigger>
            <Button.Decorative type="secondary" iconName="add">
              {i18n.t('finance.contacts.contact_details.projects.no_projects_message.button')}
            </Button.Decorative>
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="bottom" align="center">
            <PopoverMenu.TouchableOption
              title={i18n.t(
                'finance.contacts.contact_details.projects.no_projects_message.options.new'
              )}
              onClick={onClickAddButton}
            />
            <PopoverMenu.TouchableOption
              title={i18n.t(
                'finance.contacts.contact_details.projects.no_projects_message.options.link'
              )}
              onClick={onClickLinkButton}
            />
          </PopoverMenu.Content>
        </PopoverMenu>
      </Box>
    </Box>
  )
}

export default NoProjectsMessage
